import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'


import App from './App.vue'
import router from './services/router'
import vuex from './services/vuex'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css';
// eslint-disable-next-line
var Vue = createApp(App).use(vuex).use(router).use(mavonEditor).use(VueCookies).use(VueAxios, axios.create({
  baseURL:'http://120.55.95.207:9000/',
  timeout: 3000,
})).mount('#app')



export default Vue